import * as React from 'react';

import { MoreVert } from '@material-ui/icons';

import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';

import { useHistory } from 'react-router-dom';

import { USER_ACTION_CONFIG } from '../_actions/user-actions-config';
import ChangeEmailModal from '../_modals/change-email-modal';
import ChangeCohortModal from '../_modals/change-cohort-modal';
import ChangeNameModal from '../_modals/change-name-modal';
import RemovePhoneModal from '../_modals/remove-phone-modal';
import ConfirmActionModal from '../_modals/confirm-action-modal';

import {
  pauseStudent,
  startStudent,
  unenrollStudent,
} from '../services/api';
import { toast } from 'react-toastify';

const ITEM_HEIGHT = 48;

export function ActionCellRenderer(params) {
  const history = useHistory();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  // Modal state (keeping useState as decided)
  const [modalState, setModalState] = React.useState({
    changeEmail: false,
    changeCohort: false,
    changeName: false,
    removePhone: false,
    confirmAction: false,
  });

  const [pendingAction, setPendingAction] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openModal = (modalName) => {
    setModalState((prev) => ({ ...prev, [modalName]: true }));
    handleClose();
  };

  // Action handler
  const handleAction = async (actionConfig) => {
    const { handler, handlerConfig } = actionConfig;

    switch (handler) {
      case 'navigate':
        history.push({
          pathname: handlerConfig.path,
          state: {
            [handlerConfig.stateKey]: params.data,
          },
        });
        break;

      case 'openModal':
        openModal(handlerConfig.modal);
        break;

      case 'api':
        if (handlerConfig.requiresConfirm) {
          setPendingAction(actionConfig);
          openModal('confirmAction');
        } else {
          await executeApiAction(actionConfig);
        }
        break;

      default:
        console.warn(`Unknown handler: ${handler}`);
    }
  };

  // Execute API action
  const executeApiAction = async (config, reason = null) => {
    try {
      const { handlerConfig, action: actionName } = config;
      const endpoint = handlerConfig?.endpoint;
      
      if (!endpoint) {
        console.error('No endpoint found in action config');
        toast.error('Action configuration error');
        return;
      }
      
      // Map endpoint to actual API function
      if (endpoint.includes('/pause') || endpoint.includes('/archive')) {
        await pauseStudent({ 
          userId: params.data.id,
          course: params.data.UserSubscriptions_courseType || '',
        });
      } else if (endpoint.includes('/unarchive') || endpoint.includes('/start')) {
        await startStudent({
          userId: params.data.id,
          course: params.data.UserSubscriptions_courseType || '',
        });
      } else if (endpoint.includes('/unenroll')) {
        await unenrollStudent({
          userId: params.data.id,
          course: params.data.UserSubscriptions_courseType || '',
        });
      }

      toast.success(`${actionName} successful`);

      if (handlerConfig?.refreshGrid) {
        window.location.reload();
      }
    } catch (error) {
      console.error(`Error executing ${config.action}:`, error);
      const message =
        error.response?.data?.message || `Failed to ${config.action?.toLowerCase() || 'execute action'}`;
      toast.error(message);
    }
  };

  // Handle confirmed action
  const handleConfirmAction = async (reason) => {
    if (pendingAction) {
      await executeApiAction(pendingAction, reason);
      setPendingAction(null);
    }
  };

  return (
    <div>
      <IconButton
        aria-label='more'
        id='long-button'
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup='true'
        onClick={handleClick}
      >
        <MoreVert />
      </IconButton>

      <Menu
        id='long-menu'
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 8,
            width: '20ch',
          },
        }}
      >
        {USER_ACTION_CONFIG.filter((config) =>
          config.visible ? config.visible(params) : true
        ).map((config) => {
          const Icon = config.icon;
          return (
            <MenuItem
              key={config.action}
              onClick={() => handleAction(config)}
              style={config.danger ? { color: '#f44336' } : {}}
            >
              <div className='flex gap-1 items-center font-normal'>
                {Icon && <Icon fontSize='small' style={config.danger ? { color: '#f44336' } : {}} />}
                <div>{config.action}</div>
              </div>
            </MenuItem>
          );
        })}
      </Menu>

      {/* Modals */}
      <ChangeEmailModal
        params={params}
        openModal={modalState.changeEmail}
        setOpenModal={(val) => setModalState((p) => ({ ...p, changeEmail: val }))}
      />

      <ChangeCohortModal
        params={params}
        openModal={modalState.changeCohort}
        setOpenModal={(val) => setModalState((p) => ({ ...p, changeCohort: val }))}
      />

      <ChangeNameModal
        params={params}
        openModal={modalState.changeName}
        setOpenModal={(val) => setModalState((p) => ({ ...p, changeName: val }))}
      />

      <RemovePhoneModal
        params={params}
        openModal={modalState.removePhone}
        setOpenModal={(val) => setModalState((p) => ({ ...p, removePhone: val }))}
      />

      <ConfirmActionModal
        openModal={modalState.confirmAction}
        setOpenModal={(val) => setModalState((p) => ({ ...p, confirmAction: val }))}
        title={pendingAction?.handlerConfig?.confirmTitle}
        message={pendingAction?.handlerConfig?.confirmMessage}
        requiresReason={pendingAction?.handlerConfig?.requiresReason}
        onConfirm={handleConfirmAction}
      />
    </div>
  );
}
